module.exports = __webpack_public_path__ + "img/48-image-1-1@2x.48460974.png";